import { SET_PRINT_ATTRS, SET_PRINT_STYLE } from "constants/printContants";

export const styles = {
  background: "",
  backroundColor: "",
  paddingTop: 32,
  paddingRight: 32,
  paddingBottom: 32,
  paddingLeft: 32,
  borderSize: 0,
};

const initialState = {
  styles,
  attrs: [],
};

const printReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PRINT_STYLE:
      return {
        ...state,
        styles: action?.printStyle,
      };
    case SET_PRINT_ATTRS:
      return {
        ...state,
        attrs: action?.printAttrs,
      };
    default:
      return state;
  }
};

export default printReducer;
